
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoricoSegnalazioneService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  public getList(codiceSegnalazione: number, sort: string, ente: number) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('codiceSegnalazione', `${codiceSegnalazione}`);
    searchParams = searchParams.append('sort', `${sort}`);
    searchParams = searchParams.append('ente', `${ente}`);

    return this.http
      .get<ModelEventiCalamitosi.AnaDatiRaccoltiStoricoDTO[]>(`${environment.urls.base}/segnalazione/storico-segnalazione`,
        {
          params: searchParams
        });
  }

}